<template>
  <w-app>
    <div id="nav">
      <router-link to="/">People entry</router-link> |
      <router-link to="/find-people">People finder</router-link>
    </div>
    <router-view />
  </w-app>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: rgba(213, 17, 128, 0.75);
}
</style>
